/* eslint-disable no-magic-numbers */
import { Device } from '../helpers/Device'
export const MAX_TARGETING_LENGTH = 40
export const SLUG_ATTRIBUTE = 'data-slug'
export const TABLET_WIDTH = 728
export const DFP_ID = '1030006'
export const desktopOffsetMultiplier = 2.5
export const mobileOffsetMultiplier = 2.9
export const offsetTest = false
export const timeoutTest = false
export const timeout = () => {
  if (Device.isMobile) {
    return 1800
  }
  if (Device.isTablet) {
    return 2100
  }

  return 1800 // desktop
}
export const lazyTimeout = () => {
  if (Device.isMobile) {
    return 1100
  }
  if (Device.isTablet) {
    return 1400
  }

  return 1200 // desktop
}
export const refreshTimeout = () => {
  if (Device.isMobile) {
    return 1700
  }
  if (Device.isTablet) {
    return 1500
  }

  return 1200 // desktop
}
export const DEFAULT_REFRESH_INTERVAL = 28 // seconds
export const PENNY_PRECISION = 2
export const SLOT_RENDER_ATTR = 'data-slot-rendered'
export const BLACKLIST_ATTR = 'data-blacklist-'
export const BLACKLIST = 'blacklist'
export const ALL = 'all'
export const OUTSTREAM_FLOOR = 4.5
